/* eslint-disable react/no-multi-comp */
import React from "react";

import {
  FindOutMoreContainer,
  SignUpLinkContainer,
  StyledArrowRightIcon,
  StyledFillEmailIcon,
} from "./styles";

export const HomepageV2ThemeFindOutMoreDisplay: React.FunctionComponent = () => (
  <FindOutMoreContainer>
    <StyledFillEmailIcon />
    Find Out More
  </FindOutMoreContainer>
);

export const HomepageV2ThemeSignUpButtonDisplay: React.FunctionComponent = () => (
  <SignUpLinkContainer>
    Get our newsletters
    <StyledArrowRightIcon />
  </SignUpLinkContainer>
);

HomepageV2ThemeFindOutMoreDisplay.displayName = "HomepageV2ThemeFindOutMoreDisplay";
HomepageV2ThemeSignUpButtonDisplay.displayName = "HomepageV2ThemeSignUpButtonDisplay";
